import { END_POINTS } from "../constants/urls";
import { User } from "../types/User";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  statusCode: number;
  data?: User;
  message: string;
}

interface CommonResponse {
  statusCode: number;
  message?: string;
  data?: any;
}

export const userReportApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserReportList: builder.query<
      CommonResponse & { data: any },
      {
        page: number;
        limit: number;
        search?: string;
        dateFrom?: string;
        dateTo?: string;
      }
    >({
      query: ({ page, search, limit, dateFrom, dateTo }) => {
        const params = new URLSearchParams({
          page: page.toString(),
        });
        if (search) {
          params.append("search", search);
        }
        if (dateFrom && dateTo) {
          params.append("dateFrom", dateFrom);
          params.append("dateTo", dateTo);
        }
        return {
          url: `${END_POINTS.userReport}?${params}&limit=${limit}`,
          method: "GET",
        };
      },
    }),
    exportUserReportList: builder.query<
      CommonResponse & { data: any },
      { page: number; limit: number; dateFrom?: string; dateTo?: string }
    >({
      query: ({ page, limit, dateFrom, dateTo }) => {
        const params = new URLSearchParams({
          page: page.toString(),
        });
        if (dateFrom && dateTo) {
          params.append("dateFrom", dateFrom);
          params.append("dateTo", dateTo);
        }
        return {
          url: `${END_POINTS.exportUserReport}?${params}&limit=${limit}`,
          method: "GET",
        };
      },
    }),
    exportTransactionsList: builder.query<
      CommonResponse & { data: any },
      { page: number; limit: number; dateFrom?: string; dateTo?: string }
    >({
      query: ({ page, limit, dateFrom, dateTo }) => {
        const params = new URLSearchParams({
          page: page.toString(),
        });
        if (dateFrom && dateTo) {
          params.append("dateFrom", dateFrom);
          params.append("dateTo", dateTo);
        }
        return {
          url: `${END_POINTS.exportTransactions}?${params}&limit=${limit}`,
          method: "GET",
        };
      },
    }),
  }),
});
export const {
  useLazyGetUserReportListQuery,
  useLazyExportUserReportListQuery,
  useLazyExportTransactionsListQuery,
} = userReportApi;
